import { useEffect } from "react";
import { useWowSeeAnalytics } from "wowsee-analytics-react";
import { getUserId } from "../utilities/url";

export const AnalyticsTracker = () => {
  const { initialize, trackNavigation } = useWowSeeAnalytics();

  useEffect(() => {
    initialize(getUserId());

    const popstateHandler = () => {
      trackNavigation();
    };

    window.addEventListener("popstate", popstateHandler);
    return () => {
      window.removeEventListener("popstate", popstateHandler);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}